// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> weidner-apartment-homes-vantage -> bridges-apartment-homes
// Generated: 2026-10-27T17:12:56.137Z
// Counts: 0 design, 22 content, 16 slot group, 1 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.social_label": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience everyday convenience and comfort at Bridges Apartment Homes. Enjoy inviting community features, including an outdoor swimming pool, a spa, and a clubhouse perfect for gatherings. Your apartment brings comfort home with granite countertops, a full appliance package, and tall ceilings. Whether you’re seeking a place to unwind, connect, or focus on wellness, our amenities support your Salt Lake City lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions, or are you ready to start your new chapter? Reach out to our friendly leasing team for more information about life at Bridges Apartment Homes in Salt Lake City, UT. We’re here to help you find the right fit or set up a tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit with apartments for rent in Salt Lake City, UT, at Bridges Apartment Homes. Choose from our range of one-, two-, and three-bedroom layouts, each designed for modern comfort and style. Enjoy perks like granite countertops, a private balcony, spacious closets, and an in-home washer and dryer in select homes. Whether you need an efficient space for remote work or extra room to unwind, our floor plans suit every lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at Bridges Apartment Homes through our photo gallery. Picture yourself relaxing on your private balcony, prepping meals on gorgeous granite countertops, and enjoying vibrant community spaces. Browse photos to get a feel for life at Bridges - from stylish kitchens to inviting living areas and amenities that bring neighbors together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Bridges Apartment Homes puts Salt Lake City right at your doorstep. You’re steps from local favorites like Salt Palace Convention Center, Gateway Plaza, and Vivint Arena. Vibrant shops, restaurants, and entertainment venues are all close by, while parks like Gateway Community Garden, Pioneer Park, and the Jordan River offer nearby escapes into nature. Easy access to Interstate 15 and Interstate 80 makes getting around simple, and Salt Lake Central Station is within walking distance - bringing the best of the city within reach of your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Bridges means you’re close to all that downtown Salt Lake City has to offer. Stroll out your door and reach places like Salt Palace Convention Center, the Gateway Plaza shopping mall, and Vivint Arena within minutes. Green spaces like Gateway Community Garden, Pioneer Park, and the Jordan River keep the city feeling fresh and connected to the outdoors. With Salt Lake Central Station, Interstate 15, and Interstate 80 nearby, commutes to work and school are simple. Discover culture, convenience, and connection at every turn.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Salt Lake City, UT? Welcome to Bridges Apartment Homes - your new base in the heart of downtown. Here, you’re never far from favorite destinations like Vivint Arena, the Salt Palace Convention Center, and Gateway Plaza. Bridges offers well-appointed apartments in a pet-friendly, lively community, close to the TRAX Light Rail Station and with options for on-site covered or garage parking. Come home to comfort, convenience, and a friendly atmosphere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to picture your new life? Touring Bridges Apartment Homes is easy - choose the visit style that fits you best. We offer guided in-person tours, live virtual tours, or a quick peek online. Our team is here to help you take in every detail at your own pace so that you can get a sense of our Salt Lake City community, floor plans, and amenities. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover what life at Bridges Apartment Homes could look like, all from your device. Our interactive virtual tour lets you step through spacious layouts and experience the welcoming vibe of our Salt Lake City community at your own pace. Picture relaxing evenings, home-cooked meals, and friendly community moments - all before setting foot on the property. If you want a guided look, our team can walk you through highlights virtually or in person.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "contactform.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "footer.contact_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1328b-8379-7178-a222-5fe1e9a3d48f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Close-up of a businessman in a dotted shirt making a call in a lively indoor setting with warm lights."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/019d01af-999e-74ef-b63d-ecb670a83bee.webp"
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167070/01a1328b-34f6-7277-a54c-5e2dfa31f5b4.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fluffy dog peacefully resting on a bed with a wooden headboard in a cozy indoor setting."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_1871f0fc0b0a027451c7d8d4"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      9
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
